<ng-container>
  <div class="row mt-4">
    <div class="container faq-container">

      <h1 class="page-title wrapper-header">CGP RevisionHub &mdash; Frequently Asked Questions</h1>

      <!-- VIDEO: mobile only (above FAQs) -->
      <div class="video-wrapper mobile-only mb-4">
        <iframe
          src="https://www.youtube.com/embed/9IJ-TRt6jTk?enablejsapi=1&rel=0"
          allowfullscreen
          title="What is CGP RevisionHub">
        </iframe>
      </div>

      <!-- TOP SECTION: highlighted FAQs + video (desktop side-by-side) -->
      <div class="top-section">
        <div class="left-faqs">
          <div class="faq-q">What is CGP RevisionHub?</div>
          <div class="faq-a">
            Great question! CGP RevisionHub is our online platform where you can find lots of helpful
            revision, all matched to your books. Use the quizzes, tests, videos, audio and more to
            revise what you've learned from your book and practise for your exams.
          </div>

          <div class="mt-3">
            <div class="faq-q">How do I access CGP RevisionHub?</div>
            <div class="faq-a">
              You've got a couple of options here...
              <ol>
                <li>Go to <a class="link-button" href="/">CGP RevisionHub</a>, sign in and select your book</li>
                <li>Scan any QR code in your book to go straight to that resource</li>
              </ol>
              The first time you use CGP RevisionHub, you'll need to enter the unique code printed on
              the inside cover of your book. You can enter your code <a class="link-button" (click)="externalRedirect.ssoRedirect(`${environment.app.mediaBaseUrl}/revision-hub/unlock`)">here</a>.
            </div>
          </div>
        </div>

        <!-- VIDEO: desktop only (side panel) -->
        <div class="video-side">
          <div class="video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/9IJ-TRt6jTk?enablejsapi=1&rel=0"
              allowfullscreen
              title="What is CGP RevisionHub">
            </iframe>
          </div>
        </div>
      </div>

      @for (faq of faqs; track faq) {
        <div class="faq-plain">
          <h4>{{ faq.question }}</h4>
          @for (para of faq.paragraphs; track para) {
            <p [innerHTML]="para"></p>
          }
        </div>
      }

      <div class="faq-back-row">
        <a class="faq-back-btn" [href]="environment.security.baseUrl">< Back</a>
      </div>
    </div>
  </div>
</ng-container>
